import State from "../state/state.ts";
import EatOutApiClient from "../api-client/eat-out-api-client.ts";
import Route from "../enums/route.ts";
import UiUtils from "../utils/ui-utils.ts";

export default class BaseUI {
  protected readonly debug: boolean;
  protected readonly id: string;
  protected readonly container: HTMLDivElement;
  protected readonly state: State;
  protected readonly apiClient: EatOutApiClient;
  protected readonly navigateCallback: (route: Route) => void;

  constructor(
    id: string,
    state: State,
    apiClient: EatOutApiClient,
    navigateCallback: (route: Route) => void,
  ) {
    // set debug mode
    this.debug = globalThis.location.hostname === "localhost";

    // set ID
    this.id = id;

    // create container div that all fragment UI content will live
    this.container = UiUtils.div();
    this.container.classList.add("eat-out-base-ui");
    this.container.id = this.id;

    // set StateManager
    this.state = state;

    // set API client
    this.apiClient = apiClient;

    // set navigation callback
    this.navigateCallback = navigateCallback;
  }

  public render(newElements: HTMLElement[] = []): HTMLDivElement {
    this.container.replaceChildren(...newElements);
    return this.container;
  }
}
